// extracted by mini-css-extract-plugin
export default {"simplePage":"SimplePage_simplePage__UjYNF","banner":"SimplePage_banner__WWtQW","centeredContent":"SimplePage_centeredContent__j-0cz"};